import * as vp from 'vopay';

import { FunctionComponent, useContext, useMemo } from 'react';

import TransactionsContext from './TransactionsContext';
import { DialogueHandler, TransactionDialogueHandlers } from './types';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type TransactionsDialogueProps = {
  handleDialogue: DialogueHandler<TransactionDialogueHandlers>;
};

type FC = FunctionComponent<TransactionsDialogueProps>;

const TransactionsDialogue: FC = ({ handleDialogue }: TransactionsDialogueProps) => {
  const { showTransactionsSearchErrorAlert, transactionsSearchError } = useContext(TransactionsContext);
  const { showTransactionsSearchSuccessAlert, transactionsSuccessMessage } = useContext(TransactionsContext);
  const { t } = useTranslation('translations', { keyPrefix: 'PartnerAccountTransfer.Dialog' });

  return useMemo(
    () => (
      <div>
        {/* Transaction Search Error */}

        <ConfirmationDialogue
          isVisible={showTransactionsSearchErrorAlert}
          status="error"
          title={t('TransactionSearchError.title')}
          subTitle={t('TransactionSearchError.subTitle', { transactionsSearchError })}
          confirm={{
            label: t('TransactionSearchError.confirmButton'),
            action: () => handleDialogue({ type: 'search', state: 'fail', hasNavigation: false }),
          }}
        />

        {/* Transaction Success */}

        <ConfirmationDialogue
          isVisible={showTransactionsSearchSuccessAlert}
          title={t('TransactionSuccess.title', { transactionsSuccessMessage })}
          status="success"
          subTitle={t('TransactionSuccess.subTitle')}
          confirm={{
            label: t('TransactionSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'search', state: 'success', hasNavigation: true }),
          }}
        />
      </div>
    ),
    [showTransactionsSearchErrorAlert, showTransactionsSearchSuccessAlert],
  );
};

export default TransactionsDialogue;
